import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { MapPin } from "lucide-react";
export default function ServiceAreasHeader() {
  return <section id="serviceareasheader" data-nav="light" className="relative bg-background text-foreground py-12 md:py-16 lg:py-20 overflow-hidden border-b border-border/60">
      {/* Subtle architectural background accents */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div className="absolute -top-24 right-1/4 w-96 h-96 rounded-full bg-chart-1/5 blur-3xl" />
        <div className="absolute top-1/2 -left-20 w-80 h-80 rounded-full bg-chart-2/5 blur-3xl" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-30" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb Navigation */}
        <div className="mb-6 inline-flex items-center rounded-lg bg-card/80 border border-border/80 px-3.5 py-1.5 shadow-2xs backdrop-blur-sm">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors font-medium">
                    Home
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <span className="text-muted-foreground font-medium">Resources</span>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-semibold text-foreground">
                  Service Areas
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {/* Header Content Container */}
        <div className="max-w-3xl">
          <div className="flex items-center gap-2 text-chart-1 mb-3">
            <MapPin className="size-4.5 shrink-0" aria-hidden="true" />
            <span className="text-xs uppercase tracking-widest font-semibold">
              Serving Decatur & Greater Atlanta Communities
            </span>
          </div>

          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground text-balance">
            Service Areas
          </h1>

          <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed text-balance">
            Decatur Heritage Renovations delivers bespoke residential remodeling, master additions, custom kitchens, and outdoor living transformations throughout Decatur, Georgia, and adjacent historic neighborhoods.
          </p>
        </div>
      </div>
    </section>;
}